import React from 'react';
import { Mail, Music } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img
                src="https://customer-assets.emergentagent.com/job_da9e6102-b17b-4e3a-82a5-102f912074e7/artifacts/esnq4twv_S2R_logo_750x750.png"
                alt="S2R Logo"
                className="h-12 w-auto"
              />
              <span className="text-lg font-bold">SongsToRepresent</span>
            </div>
            <p className="text-gray-400 text-sm">
              Skräddarsydd musik för idrottsklubbar som vill representeras med stil.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Snabblänkar</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('hem')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Hem
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('om-oss')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Om oss
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('exempel')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Exempel
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('kontakt')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Kontakt
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
            <div className="space-y-3">
              <a
                href="mailto:songstorepresent@gmail.com"
                className="flex items-center space-x-2 text-gray-400 hover:text-white transition-colors duration-200"
              >
                <Mail className="w-5 h-5" />
                <span>songstorepresent@gmail.com</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} SongsToRepresent. Alla rättigheter förbehållna.
            </p>
            <div className="flex items-center space-x-2 text-gray-400 text-sm">
              <Music className="w-4 h-4" />
              <span>Skapad med passion för musik och idrott</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;